var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKutxis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1109 0.880127H5.55533C5.34037 0.880127 5.16643 1.05407 5.16643 1.26903C5.16643 1.48399 5.34037 1.65793 5.55533 1.65793H13.1721L0.613697 14.2163C0.461775 14.3682 0.461775 14.6143 0.613697 14.7662C0.68964 14.8421 0.789171 14.8801 0.888666 14.8801C0.988161 14.8801 1.08766 14.8421 1.16364 14.7662L13.722 2.20783V9.8246C13.722 10.0396 13.8959 10.2135 14.1109 10.2135C14.3259 10.2135 14.4998 10.0396 14.4998 9.8246V1.26903C14.4998 1.05407 14.3258 0.880127 14.1109 0.880127Z",
    fill: "#405FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKutxis);
export default __webpack_public_path__ + "static/media/kutxis.b2e1783b8dc555a0f599f072a5769234.svg";
export { ForwardRef as ReactComponent };